export default __webpack_public_path__ + "static/media/flowerOne.e92a2eff.jpg";